export default function ProgressDots({ sections, activeIndex, onSelect }) {
  return (
    <div
      className="pointer-events-auto fixed right-5 md:right-8 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-center gap-4 md:flex"
      data-testid="progress-dots-nav"
    >
      {sections.map((s, i) => (
        <button
          key={s.id}
          type="button"
          data-testid={`progress-dot-${s.id}`}
          onClick={() => onSelect(i)}
          aria-label={`Go to ${s.label}`}
          className="group relative flex items-center justify-end"
        >
          <span
            className={`h-[7px] w-[7px] rounded-full transition-all duration-300 ${
              i === activeIndex
                ? "bg-[#01FFFF] shadow-[0_0_8px_#01FFFF]"
                : "bg-[#8A9AAB]/40 group-hover:bg-[#8A9AAB]"
            }`}
          />
          <span className="pointer-events-none absolute right-4 whitespace-nowrap font-mono text-[10px] uppercase tracking-widest text-[#8A9AAB] opacity-0 transition-opacity duration-200 group-hover:opacity-100">
            {s.number} — {s.label}
          </span>
        </button>
      ))}
    </div>
  );
}
